import { ref, onMounted } from 'vue'
import liff from '@line/liff'

export function useLiff () {
  const isInitialized = ref(false)
  const isLoggedIn = ref(false)
  const liffId = ref('')
  const idToken = ref('')
  const userProfile = ref({ displayName: '' })
  const effectiveLiffId = ref('')

  try {
    const pathSegments = location.pathname.split('/')
    const pathLiffId = pathSegments.length > 2 ? pathSegments[2] : ''
    const envLiffId = import.meta.env.VITE_LIFF_ID
    effectiveLiffId.value = pathLiffId || envLiffId
  } catch (e) {
    console.log(e)
    alert('LIFF IDの取得に失敗しました')
  }

  async function initializeLiff () {
    try {
      await liff.init({ liffId: effectiveLiffId.value })
      isInitialized.value = true
      isLoggedIn.value = liff.isLoggedIn()
      liffId.value = effectiveLiffId.value

      if (!isLoggedIn.value) {
        liff.login()
        return
      }
      idToken.value = liff.getIDToken()

      console.log('LIFF Initialization complete:', {
        isInitialized: isInitialized.value,
        isLoggedIn: isLoggedIn.value,
        liffId: liffId.value,
        idToken: idToken.value,
      })
    } catch (error) {
      console.error('LIFF Initialization failed:', error)
    }
  }

  // ユーザープロフィール(ニックネーム)を取得する
  async function fetchProfile () {
    try {
      const profile = await liff.getProfile()
      userProfile.value = {
        displayName: profile.displayName,
      }
      console.log('Fetched user profile:', userProfile.value)
    } catch (error) {
      console.error('Failed to get line profile:', error)
    }
  }

  // onMounted(async () => {

  // effectiveLiffId.value = pathLiffId

  // if (effectiveLiffId.value) {
  //   initializeLiff(effectiveLiffId.value)
  // } else {
  //   console.log('LIFF Initialization failed: liffId is missing')
  // }
  // })

  async function getAuthHeaders () {
    if (!isInitialized.value) {
      await initializeLiff()
    }
    console.log('getAuthHeaders idToken:', idToken.value)
    console.log('getAuthHeaders liffId:', liffId.value)
    return {
      'line-id-token': idToken.value,
      'liff-id': liffId.value,
    }
  }

  function closeWindow () {
    liff.closeWindow()
  }

  return {
    isInitialized,
    isLoggedIn,
    idToken,
    liffId,
    userProfile,
    effectiveLiffId,
    initializeLiff,
    getAuthHeaders,
    closeWindow,
    fetchProfile,
  }
}
